import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  fetchTagsPostList: ['tagName', 'pageNumber'],
  fetchTagsPostListStart: null,
  fetchTagsPostListSuccess: ['tagsPostList'],
  fetchTagsPostListFailure: null,

  increasePostCount: ['postId']
});

export { Types, Creators };
